import { NgModule } from '@angular/core';

import { PriceBaseService2 } from './price-base.service';
import { PriceService2 } from './price.service';
import { PriceDictionaryService } from './price-dictionary.service';
import { PriceComplexService } from './price-complex.service';
import { PriceExternalVenetianService } from './price-external-venetian.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        PriceService2,
        PriceBaseService2,
        PriceDictionaryService,
        PriceComplexService,
        PriceExternalVenetianService,
    ],
})
export class PriceModule2 {}
